import { imageSchema, universalLink } from '../../questions/schemaFields';
import { createBasicScreenSchema } from '../schemaFields';

export const schema = createBasicScreenSchema(
  'SYSTEM_SCREEN',
  {
    cause: { enum: ['UNKNOWN_ERROR', 'INCORRECT_CONFIGURATION', 'WITHDRAWN', 'COMPLETED'] },
    image: imageSchema,
    title: { type: 'string' },
    text: { type: 'string' },
    cta: { type: 'string' },
    ctaUrl: universalLink,
    alignContent: { enum: ['center', 'left'] },
  } as const,
  ['cause', 'title', 'alignContent'],
);
